module.exports = __webpack_public_path__ + "img/TechInfCombinedArms_ua.c8ba21b4.webp";